import ContactSection from "@/components/ContactSection";

export default function Contact() {
  return (
    <div data-testid="contact-page">
      <section className="relative overflow-hidden bg-slate-50 text-slate-900">
        <div className="absolute inset-0 bg-grid-soft opacity-[0.06] pointer-events-none" />
        <div className="absolute -top-32 -right-32 h-[480px] w-[480px] rounded-full bg-[#10B981]/18 blur-3xl" />
        <div className="relative max-w-[1400px] mx-auto px-4 sm:px-6 lg:px-10 pt-40 md:pt-48 pb-20 md:pb-28">
          <div className="text-[11px] font-semibold tracking-[0.28em] text-[#10B981] uppercase mb-5">Contact</div>
          <h1 className="font-display text-4xl sm:text-5xl lg:text-7xl font-bold tracking-[-0.025em] text-balance leading-[1.02] max-w-4xl">
            Un projet, une question, un audit ? Parlons-en.
          </h1>
          <p className="mt-7 text-base md:text-xl text-slate-600 max-w-2xl leading-relaxed">
            Industriel, exploitant tertiaire, gestionnaire de patrimoine ou particulier — nos
            chargés d&apos;affaires répondent sous 48 heures ouvrées.
          </p>
        </div>
      </section>
      <ContactSection compact />
    </div>
  );
}
